export default __webpack_public_path__ + "static/media/4ab72453-3762-46f5-ab6e-043dfad8827d.8aa4bd36.jpg";